import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Apartment {
  id: string;
  name: string;
  tagline: string;
  size: string;
  guests: string;
  bedrooms: string;
  image: string;
  alt: string;
  features: string[];
  priceFrom: string;
}

export default function ApartmentPreview() {
  const apartments: Apartment[] = [
  {
    id: 'luxos',
    name: 'Luxos Luxury',
    tagline: 'Executive Excellence Redefined',
    size: '400 sq ft',
    guests: 'Up to 2 adults & 1 child (under 6 years)',
    bedrooms: '1 BHK',
    image: "/assets/images/IMG20251021160224_copy-1767696990093.jpg",
    alt: 'Luxurious Luxos apartment with premium furnishings, wooden flooring, elegant beige walls, and pristine white bedding',
    features: ['Premium Amenities', 'Luxury Furnishings', 'Spacious Layout', 'Executive Comfort'],
    priceFrom: '₹4,750'
  },
  {
    id: 'primera',
    name: 'Primera Premium',
    tagline: 'Modern Comfort, Thoughtfully Designed',
    size: '400 sq ft',
    guests: 'Up to 2 adults & 1 child (under 6 years)',
    bedrooms: '1 BHK',
    image: "/assets/images/IMG20251018151027_copy-1767697078477.jpg",
    alt: 'Modern Primera bedroom with wooden headboard featuring backlit design, pristine white bedding, ceiling fan, air conditioning, and beige walls',
    features: ['Modern Comfort', 'Stylish Décor', 'Smart Space Design', 'High-Speed WiFi'],
    priceFrom: '₹3,850'
  },
  {
    id: 'classica',
    name: 'Classica Comfort',
    tagline: 'Timeless Comfort, Modern Convenience',
    size: '400 sq ft',
    guests: 'Up to 2 adults & 1 child (under 6 years)',
    bedrooms: '1 BHK',
    image: "/assets/images/IMG20251029135419_1copy-1767817703345.jpg",
    alt: 'Bright Classica studio apartment featuring white walls, ceiling fan, modern furnishings, comfortable bed with floral bedding, and golden curtains',
    features: ['Classic Design', 'Cozy Ambiance', 'Essential Amenities', 'Value Pricing'],
    priceFrom: '₹3,100'
  }];


  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary mb-4">
            Choose Your Perfect Space
          </h2>
          <p className="text-lg text-text-secondary">
            Three unique apartment categories designed to match your lifestyle and business needs
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {apartments.map((apartment) =>
          <div
            key={apartment.id}
            className="group bg-white rounded-2xl overflow-hidden shadow-subtle hover:shadow-premium transition-all duration-300">

              <div className="relative h-80 overflow-hidden">
                <AppImage
                src={apartment.image}
                alt={apartment.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute top-4 right-4 bg-accent text-white px-4 py-2 rounded-full text-sm font-semibold">
                  {apartment.priceFrom}/night
                </div>
              </div>

              <div className="p-8 space-y-6">
                <div>
                  <div className="text-sm text-accent font-semibold mb-2">{apartment.tagline}</div>
                  <h3 className="text-2xl font-display font-bold text-primary mb-3">
                    {apartment.name}
                  </h3>
                  <div className="flex flex-wrap gap-4 text-sm text-text-secondary">
                    <div className="flex items-center space-x-2">
                      <Icon name="HomeIcon" size={16} className="text-accent" />
                      <span>{apartment.size}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="UserGroupIcon" size={16} className="text-accent" />
                      <span>{apartment.guests}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="HomeModernIcon" size={16} className="text-accent" />
                      <span>{apartment.bedrooms}</span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  {apartment.features.map((feature, index) =>
                <div key={index} className="flex items-center space-x-2 text-sm text-text-secondary">
                      <Icon name="CheckCircleIcon" size={16} className="text-success flex-shrink-0" />
                      <span>{feature}</span>
                    </div>
                )}
                </div>

                <div className="flex gap-3 pt-4">
                  <Link
                  href="/apartment-categories"
                  className="flex-1 px-6 py-3 bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg text-center transition-all duration-300 hover:scale-105">

                    View Details
                  </Link>
                  <a
                    href="https://bookingengine.stayflexi.com/?hotel_id=33526"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 px-6 py-3 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg text-center transition-all duration-300 hover:scale-105">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}